import { API } from "../../../utils";

export const getTenantBusinessDetailsApi = async () => {
  const res = await API.get("/settings/business_details");
  return res.data;
};

export const updateTenantBusinessDetailsApi = async (payload) => {
  const res = await API.put("/settings/business_details", payload);
  return res.data;
};